<div class="bp-page">

    <!-- HEADER -->
    <div class="bp-head">
        <div>
            <h3 class="bp-title">
                <i class="bi bi-credit-card"></i>
                My Billing
            </h3>
            <div class="bp-sub">Manage your payment methods</div>
        </div>
    </div>

    <!-- PROFILE -->
    <div class="bp-grid">

        <div class="bp-card" *ngIf="profile">

            <div class="top">
                <div class="avatar">
                    <i class="bi bi-person"></i>
                </div>

                <div class="info">
                    <div class="name">{{ profile?.patientId?.fullName }}</div>
                    <div class="muted small">{{ profile?.patientId?.email }}</div>
                </div>

                <div class="status">
                    <span class="pill pill-success">
                        {{ profile.status }}
                    </span>
                </div>
            </div>

            <div class="mid">
                <div class="kv">
                    <div class="k text-dark">Currency</div>
                    <div class="v">{{ profile.currency }}</div>
                </div>

                <div class="kv">
                    <div class="k text-dark">AutoPay</div>
                    <div class="v">
                        {{ profile.autopayEnabled ? 'Enabled' : 'Disabled' }}
                    </div>
                </div>
            </div>

            <!-- 🔥 ACTIONS -->
            <div class="actions">
                <button class="btn btn-soft" (click)="openDetails()">
                    <i class="bi bi-box-arrow-up-right"></i> Open
                </button>

                <!-- 🔥 NEW BUTTON -->
                <button class="btn btn-teal" (click)="openAttachCardModal()">
                    <i class="bi bi-credit-card"></i> Attach Card
                </button>
            </div>

        </div>

    </div>

</div>

<!-- 🔥 MODAL -->
<div class="bp-backdrop" *ngIf="modalOpen" (click)="closeModal()"></div>

<div class="bp-modal" *ngIf="modalOpen">
    <div class="bp-modal-card" (click)="$event.stopPropagation()">

        <!-- HEADER -->
        <div class="bp-modal-head">
            <div class="ttl-wrap">
                <div class="ttl">
                    <i class="bi bi-wallet2"></i>
                    Payment Methods
                </div>
                <div class="sub">
                    Manage your saved cards for fast & secure checkout
                </div>
            </div>

            <button class="btn btn-soft" (click)="closeModal()">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <div class="bp-modal-body">

            <!-- LOADING -->
            <div *ngIf="detailsLoading" class="loading-box">
                Loading...
            </div>

            <div *ngIf="!detailsLoading">

                <!-- ACTION BAR -->
                <div class="bp-actions-bar">
                    <div class="left">
                        <span class="count">
                            {{ selectedCards?.length || 0 }} Cards
                        </span>
                    </div>

                    <div class="right">
                        <button class="btn btn-primary btn-glow" (click)="openAttachCardModal()">
                            <i class="bi bi-plus-lg"></i>
                            Add New Card
                        </button>
                    </div>
                </div>

                <!-- SECURITY STRIP -->
                <div class="security-strip">
                    <i class="bi bi-shield-lock"></i>
                    Your payment information is securely encrypted
                </div>

                <!-- CARDS -->
                <div class="cards-grid" *ngIf="selectedCards?.length">

                    <div class="card-shell" *ngFor="let c of selectedCards" [class.is-default]="c.isDefault">

                        <div class="card-glow"></div>
                        <div class="card-shine"></div>

                        <div class="card-top">
                            <div class="brand">
                                {{ c.brand || 'CARD' }}
                            </div>

                            <div class="chip chip-right">
                                <img
                                    src="https://png.pngtree.com/png-vector/20231223/ourmid/pngtree-credit-card-chip-shopping-png-image_11198229.png" />
                            </div>
                        </div>

                        <div class="card-number">
                            •••• •••• •••• {{ c.last4 }}
                        </div>

                        <div class="card-mini-row">
                            <div class="mini">
                                <div class="k text-white">EXP</div>
                                <div class="v text-white">
                                    {{ (c.expMonth || 0) | number:'2.0' }}/{{ c.expYear?.toString().slice(-2) }}
                                </div>
                            </div>

                            <div class="mini">
                                <div class="k text-white">CVC</div>
                                <div class="v text-white">•••</div>
                            </div>
                        </div>

                        <div class="card-row single">
                            <div class="kv">
                                <div class="k">Card Holder</div>
                                <div class="v text-white">
                                    {{ c.billingName || 'CARD HOLDER' }}
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <div class="small muted2">
                                {{ c.isDefault ? 'Default Card' : 'Saved Card' }}
                            </div>

                            <div class="secure">
                                <span class="lock"></span>
                                Secure
                            </div>
                        </div>

                        <!-- ACTIONS -->
                        <div class="card-actions">

                            <span *ngIf="c.isDefault" class="pill pill-success">
                                DEFAULT
                            </span>

                            <button class="btn btn-danger-soft btn-sm" (click)="removeCard(c.stripePaymentMethodId)">
                                Remove
                            </button>

                        </div>

                    </div>

                </div>

                <!-- EMPTY -->
                <div *ngIf="!selectedCards?.length" class="bp-empty">
                    <i class="bi bi-credit-card-2-front"></i>

                    <div class="title">No cards added</div>
                    <div class="desc">
                        Add a card to enable quick and secure payments
                    </div>

                    <button class="btn btn-primary btn-glow">
                        Add Card
                    </button>
                </div>

            </div>

        </div>

    </div>
</div>